import { createContext, useContext } from 'react';
import { INotificationInfo, INotificationEventManager, NotificationEvent } from './notification-types';
import { EventManager } from '../../utils/event-manager';

export function createNotificationEventManager(): INotificationEventManager {
    const eventManager = new EventManager<NotificationEvent>();

    return {
        showNotifications(...notifications: INotificationInfo[]) {
            eventManager.emit('showNotification', ...notifications);
        },
        removeNotification(id: string) {
            eventManager.emit('removeNotification', id);
        },
        clearNotifications() {
            eventManager.emit('removeNotification');
        },
        subscribe: eventManager.on,
        unsubscribe: eventManager.off
    };
}

export const NotificationEventContext = createContext<INotificationEventManager>(createNotificationEventManager());

export const useNotificationEvents = () => useContext(NotificationEventContext);
